export default function capitalizeFirst (string) {
  return string.split('-').map(item => item.replace(/^\w/, char => char.toUpperCase())).join('')
}
